

export function enumDescription(target: any, propertyName: string): string | undefined {
  return target.constructor._descriptions?.[propertyName];
}

export function getEnumValues(target: any): Array<{ property: string; value: any; description: string }> {
  const descriptions = target.constructor.prototype._Enuns[target.name]._descriptions || {};
  return Object.keys(descriptions).map((property) => ({
    property,
    value: target[property],
    description: descriptions[property],
  }));
}
